import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";

const ModalErrorMessage = () => {

    return (
        <VStack spacing="Two" align="center" justify="center" style={{ minHeight: '300px' }}>
            <Text variant="Body_1_2" color="Orange_1" align="center">
                Unable to load form data
            </Text>
            <Text variant="Body_2_1" color="Gray_3" align="center">
                Please refresh the page and try again
            </Text>
        </VStack>
    );
}

ModalErrorMessage.propTypes = {};

export default ModalErrorMessage;